<p>
  {{ 'STEP3.INTRODUCTIONTEXT' | translate }}
</p>
<div class="label-pro-holder">
  <Label>{{ 'STEP3.WIDTHINTERNAL' | translate }}</Label>
  <div *ngIf="widthPro" class="product-classification-box">
    <span class="product-classification-box-icon">Pro</span>
  </div>
</div>
<app-step-three-slider
  [selectId]="'width-slider'"
  #widthSlider
  [max]="maxWidth"
  [min]="900"
  [step]="300"
  [(value)]="width"></app-step-three-slider>
<div class="label-pro-holder">
  <Label>{{ 'STEP3.LENGTHINTERNAL' | translate }}</Label>
  <div *ngIf="lengthPro" class="product-classification-box">
    <span class="product-classification-box-icon">Pro</span>
  </div>
</div>
<app-step-three-slider
  [selectId]="'length-slider'"
  #lengthSlider
  [max]="maxLength"
  [min]="900"
  [step]="300"
  [(value)]="length"></app-step-three-slider>
<div class="label-pro-holder">
  <Label>{{ 'STEP3.HEIGHTINTERNAL' | translate }}</Label>
  <div *ngIf="heightPro" class="product-classification-box">
    <span class="product-classification-box-icon">Pro</span>
  </div>
</div>
<app-step-three-slider
  [selectId]="'height-slider'"
  #heightSlider
  [max]="3900"
  [min]="1800"
  [step]="300"
  [(value)]="height"></app-step-three-slider>
